import { render, staticRenderFns } from "./conteudo.vue?vue&type=template&id=0f66b4fc"
import script from "./conteudo.vue?vue&type=script&lang=js"
export * from "./conteudo.vue?vue&type=script&lang=js"
import style0 from "./conteudo.vue?vue&type=style&index=0&id=0f66b4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports